import React from 'react';
import CardAboutSteps from '../CardAboutSteps/CardAboutSteps';
import FontsDefault from '../../Assistant/DefaultStyle';
import { DefaultFlex, DefaultFlexCenter } from '../../Assistant/DefaultStyle';

function AboutStepsSection() {
  return (
    <div className={`${FontsDefault.defaultContainerWidth}`}>
      <div className={`${DefaultFlexCenter}`}>
        <h1
          className={`bg-amber border text-center rounded-2xl font-bold text-lg py-2 px-6`}
        >
          إستراتيجية العمل في شركة  GE Step
        </h1>
      </div>

      <div className={`${DefaultFlexCenter} mt-2`}>
        <h1
          className={`mb-2 mt-4 md:${FontsDefault.text4xl} text-xl font-bold tracking-tight text-gray700`}
        >
          خطوات نتبعها لإنجاز المشاريع بأفضل جودة
        </h1>
      </div>

      <div className={`md:${DefaultFlex} text-center mt-6`}>
        <CardAboutSteps
          img='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/Critical%20thinking-cuate.svg?alt=media&token=d842c38f-b955-4892-8e11-c017c9ebedc5'
          title='الفكرة'
        />
        <CardAboutSteps
          img='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/People%20search-cuate.svg?alt=media&token=c1e3b650-6c65-4365-a578-7dffddd3dd52'
          title='البحث'
        />
        <CardAboutSteps
          img='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/Business%20Plan-cuate.svg?alt=media&token=319622f2-8ed6-4278-a8a1-567693574c2b'
          title='التخطيط'
        />
        <CardAboutSteps
          img='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/Process-cuate.svg?alt=media&token=c9a7109a-6a12-49e1-8304-6718468b0e8f'
          title='التنفيذ'
        />
        <CardAboutSteps
          img='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/Mobile-pana.svg?alt=media&token=bd3026d9-a0c6-4138-a151-3e997f3376dd'
          title='تسليم المشروع '
        />
      </div>
    </div>
  );
}

export default AboutStepsSection;
